import dayjs from 'dayjs';

import { CatchHistoryRecord } from 'pages/HistoricalCatch/HistoricalCatchControls/helpers';
import { GA } from 'services/analytics';
import { SettingsService } from 'services/settings';
import { PARAMS_MAP, START_YEAR, WEIGHT_RANGE } from './catchesConstants';

import {
  TCatchesPeriod,
  TCatchFilterOptions,
  TCatchFilterSettings,
  TSelectOption
} from 'types';

/**/
const ZERO = 1;
const WEEKS_IN_YEAR = 53;

/**
 *
 */
export function storeHCParams(values: {
  isCatchMode?: boolean;
  options?: Partial<TCatchFilterSettings>;
  period?: Partial<TCatchesPeriod>;
}): void {
  const settings =
    SettingsService.readSettings()[SettingsService.HISTORICAL_CATCH_FILTER];

  const val = {
    ...settings,
    ...values
  };

  SettingsService.writeSettings({
    [SettingsService.HISTORICAL_CATCH_FILTER]: val
  });
}

/**
 *
 */
export function reportPeriodChange(value: Partial<TCatchesPeriod>) {
  const [key, val] = Object.entries(value)[0];
  let date;

  if (key === 'years') {
    date = (val as number[]).join(',');
  } else {
    date = dayjs(START_YEAR)
      .dayOfYear(val as number)
      .format('D MMM');
  }
  GA.reportHistoricalTrack((key as string).toUpperCase(), date);
}

/**
 *
 */
export function reportOptionChange(
  values: Partial<TCatchFilterSettings>,
  options: TCatchFilterOptions
) {
  const [key, val] = Object.entries(values)[0];
  let value;

  if (typeof val === 'boolean') {
    return;
  } else if (val.length === 0) {
    value = 'ALL';
  } else if (key === 'vessels') {
    value = val.length;
  } else if (key === 'weight') {
    value = val;
  } else {
    value = extractOptions(options[key], val);
  }

  GA.reportHistoricalTrack((key as string).toUpperCase(), value);
}

/**
 *
 */
function extractOptions(
  options: TSelectOption<number>[],
  values: number[]
): string {
  return options
    .filter((o: TSelectOption<number>) => values.includes(o.value))
    .map((o: TSelectOption<number>): string => o.label)
    .join(',');
}

/**
 *
 */
export function buildQuery(
  settings: TCatchFilterSettings,
  period: TCatchesPeriod
): string {
  let query = '';
  let options = null;
  let weight = null;

  if (settings) {
    const { weight: w, ...rest } = settings;
    weight = w;
    options = rest;
  }

  Object.entries({ ...options, ...period }).forEach(
    ([key, val]: [string, number | number[]]) => {
      const k = PARAMS_MAP[key];
      if (!k || val === void 0 || (val as number[]).length === 0) return;

      if (Array.isArray(val)) {
        val.forEach((v: number) => (query += `&${k}=${v}`));
      } else {
        query += `&${k}=${val}`;
      }
    }
  );

  return `?${query.slice(1)}${weight ? handleWeight(weight) : ''}`;
}

/**
 *
 */
function handleWeight([min, max]: number[]): string {
  let query = '';

  if (min !== 0) {
    query += `&minWeight=${min * 1e3}`;
  }
  if (max !== WEIGHT_RANGE[1]) {
    query += `&maxWeight=${max * 1e3}`;
  }
  return query;
}

/**
 *
 */
export function mapCatchData(data, years: number[]): CatchHistoryRecord[] {
  const map = new Map();

  Array(WEEKS_IN_YEAR)
    .fill(null)
    .forEach((_, idx) =>
      map.set(idx + 1, new CatchHistoryRecord(idx + 1, years))
    );

  data?.forEach(({ interval, weight, year }) =>
    map.get(interval.index).addValue(year, weight || ZERO)
  );

  return Array.from(map.values());
}
